var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStethoscope = function SvgStethoscope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    d: "M33.82 16.058a4.366 4.366 0 1 1-8.732.025 4.366 4.366 0 0 1 8.732-.025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    d: "M31.637 16.064a2.183 2.183 0 1 1-4.367.013 2.183 2.183 0 0 1 4.367-.013M7.181 3H3.83A1.83 1.83 0 0 0 2 4.829v5.252h3.657V6.657h1.5239999999999998a1.83 1.83 0 0 0 0-3.657M20.13 3h-3.352a1.83 1.83 0 0 0 0 3.657h1.524v3.424h3.657V4.83A1.83 1.83 0 0 0 20.13 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M28.54 20.335v1.102c0 4.498-3.401 8.158-7.582 8.158h-.482c-3.617 0-6.646-2.74-7.398-6.392 4.97-.445 8.881-4.627 8.881-9.711V10.08h-3.657v3.41a6.104 6.104 0 0 1-6.097 6.098h-.45a6.104 6.104 0 0 1-6.098-6.097V10.08H2v3.41c0 5.2 4.093 9.45 9.225 9.729.795 4.658 4.636 8.204 9.251 8.204h.482c5.19 0 9.41-4.48 9.41-9.987v-1.1q-.436.096-.9.099c-.32 0-.629-.037-.928-.1"
  }))));
};
export default SvgStethoscope;